import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import PunchCardLogo from "../logos/PunchCardLogo";
import SignIn from "../SignIn";
import { User } from "../../modules/users/types";
import AnimatedBackground from "../AnimatedBackground";
import Container from "../Container";

interface AuthPageProps {
  onSignInSuccess: (user: User) => void;
}

const AuthPage: React.FunctionComponent<AuthPageProps> = ({
  onSignInSuccess,
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  const handleSignInSuccess = (user: User) => {
    setError(null);
    onSignInSuccess(user);
  };

  return (
    <AnimatedBackground>
      <Container>
        <div className="w-full max-w-md">
          <Card className="shadow-xl bg-card/95 backdrop-blur-sm">
            <CardHeader className="items-center">
              <PunchCardLogo type="icon" />
            </CardHeader>
            <CardContent>
              {error && (
                <div className="bg-destructive/10 border border-destructive/40 px-4 py-3 rounded mb-4">
                  <Text variant="sm" className="text-destructive">{error}</Text>
                </div>
              )}

              <Heading level={1} variant="sm" className="mb-6">Sign In</Heading>

              <SignIn onSuccess={handleSignInSuccess} onError={handleError} />
            </CardContent>
            <CardFooter className="border-t justify-center">
              <Text variant="sm" className="text-muted-foreground">
                Don&apos;t have an account?{" "}
                <Link to="/waitlist" className="text-primary hover:underline">
                  Join the waitlist
                </Link>
              </Text>
            </CardFooter>
          </Card>
        </div>
      </Container>
    </AnimatedBackground>
  );
};

export default AuthPage;

